// @ts-check

import FastlinkProvider from './fastlink.provider';

const MODULE_NAME = 'fastlink';

angular
  .module(MODULE_NAME, [])
  .provider('FastlinkService', FastlinkProvider);

export const moduleName = MODULE_NAME;
export const providerName = 'fastlinkProvider';

export default {
  moduleName,
}
